import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=374331a1&scoped=true"
import script from "./menu.js?vue&type=script&lang=js&external"
export * from "./menu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374331a1",
  null
  
)

export default component.exports